import { Button, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';





const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-wrap font-medium dark:text-white',
    render: (_, record) => <Badge className={record.status !== 'draft' ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.status}</Badge>
  },
  
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right', 
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/budgets/'+record.seo}>
        EDIT
      </Link>
    )
  }
]



const Budgets = () => {
  const budgets = useLoaderData();
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Budgets</h3>
        <div class=' bg-white dark:bg-gray-900'>
          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/budgets/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        dataSource={budgets}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'_id'}
      />
      
    
    </div>
  )
}

export default Budgets;